import { combineReducers } from 'redux';

import tab from '#modules/state/TabState';
import settings from '#modules/state/SettingsState';
import activity from '#modules/state/ActivityState';
import contract from '#modules/state/ContractState';
import warnings from '#modules/state/WorkspaceWarningState';

const reducers = combineReducers({
  settings,
  activity,
  contract,
  tab,
  warnings,
});

export default reducers;
